@switch (column().key) {
  @case (getColumnKey('type')) {
    {{ model().type | warehouseProductType | async }}
  }

  @case (getColumnKey('quantityUnit')) {
    {{ model().quantityUnit | quantityUnit | async }}
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="column().key" />
  }
}
